// extracted by mini-css-extract-plugin
export default {"container":"Region_container__c8J8Q","content":"Region_content__XqSmT"};